import React from 'react';
import { Icon } from './index';

const SkholeIcon20 = Icon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    enableBackground="new 0 0 40 40"
    version="1.1"
    viewBox="0 0 40 40"
    xmlSpace="preserve"
  >
    <defs>
      <path
        id="SVGID_5_"
        d="M33.7 31.1H32l-4-8.8c0-.3-.1-.5-.3-.7L21.1 7.2l-.1-.1c0-.1-.1-.1-.1-.2-.1-.1-.1-.1-.2-.1l-.1-.1c-.1 0-.2 0-.2-.1H20c-.1 0-.2 0-.2.1h-.1c-.1 0-.1.1-.1.1-.1 0-.1.1-.2.1-.3 0-.3.1-.4.2l-.1.1L8 31.1H6.3c-.6 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2H12c.6 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2h-1.4l3.4-7.5h12l3.4 7.5H28c-.6 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h5.6c.6 0 1.2-.5 1.2-1.2s-.5-1.2-1.1-1.2zm-18.6-9.8L20 10.5l4.9 10.8h-9.8z"
      />
    </defs>
    <use
      fillRule="evenodd"
      clipRule="evenodd"
      overflow="visible"
      xlinkHref="#SVGID_5_"
    />
    <clipPath id="SVGID_2_">
      <use overflow="visible" xlinkHref="#SVGID_5_" />
    </clipPath>
  </svg>,
);

export default SkholeIcon20;
